import bech32 from "../utils/bech32_ada";

// bip 173 bech 32 addresses (https://github.com/bitcoin/bips/blob/master/bip-0173.mediawiki)
export default {
  isValidAddress(address, currency, opts = {}) {
    const decoded = bech32.decode(address, bech32.encodings.BECH32);
    if (!decoded || !decoded.hrp) {
      return false;
    }

    return decoded.hrp === "erd";
  },
};
